import { jsx } from "panel";
import { SelectEl } from "common/components/select";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonBarEl } from "common/components/button-bar";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { InviteUsersModalEl } from "common/widgets/invite-users-modal";
import { ToastPortalEl } from "common/components/toast-portal";
import { LoadEntityModalEl } from "common/widgets/load-entity-modal";
import { CreateProjectModalEl } from "common/widgets/create-project-modal";
import { OrganizationIconEl } from "common/widgets/organization-icon";
import { ProjectFeatureFlag, ReportName } from "common/report/constants";
import { FestiveMode } from "common/util/festive-mode";
import { ButtonBarTheme } from "common/components/button-bar/types";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { events, track } from "common/report/util/settings-tracking";
import { numberInUSD } from "common/util";
import { OnboardingChecklistEl } from "common/widgets/onboarding-checklist";
import { BrowseEntityTypeFilter } from "common/report/util/search";
import { getReportName } from "common/report/util";
import { useInviteV2 } from "common/report/util/feature-sampling";
import { InviteUsersModalEl as InviteUsersModalElV2 } from "common/widgets/invite-users-modal-v2";
import { Tab } from "common/widgets/invite-users-modal-v2/types";
import { NavCategoryType } from "./constants";
import { SupportWidgetEl } from "./support-widget";
import { FestiveModeHeaderAnimEl } from "./festive-mode-header-anim";
import { ReportsMenuEl } from "./reports-menu";
import { GlobalSearchEl } from "./global-search";
export function template() {
  var _a, _b, _c, _d, _e;
  if (this.isDownloadMode()) {
    return /* @__PURE__ */ jsx("div", null);
  }
  const {
    categories,
    createProjectError,
    currentReportName,
    errorAlertMsg,
    inviteModalOrgs,
    isOpen,
    isSupportWidgetMaximized,
    projectId,
    projectMenuWorkspaces,
    searchedText,
    selectedCategory,
    showSupportWidget
  } = this.state;
  const shouldDisplayNavigationOptions = this.helpers.shouldDisplayNavigationOptions();
  const festiveMode = this.helpers.getFestiveMode();
  const currentWorkspace = this.helpers.getCurrentWorkspace();
  const workspaceId = this.currentWorkspaceId;
  const searchModalDisplayContext = this.helpers.getSearchModalDisplayContext();
  const dataManagementMenu = /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-data-management",
    class: {
      "mp-chrome-header-trigger-container-active": isOpen.dataManagementMenu
    },
    on: { click: () => this.helpers.selectMenuChanged(`dataManagement`, !isOpen.dataManagementMenu) }
  }, isOpen.dataManagementMenu ? /* @__PURE__ */ jsx(ReportsMenuEl, {
    attrs: {
      "current-report-name": currentReportName,
      "project-id": projectId,
      reports: JSON.stringify(this.helpers.getNavReportsFromCategory(NavCategoryType.DataManagement)),
      order: JSON.stringify(Object.keys(this.helpers.getNavReportsFromCategory(NavCategoryType.DataManagement))),
      open: true,
      "workspace-id": workspaceId
    },
    on: {
      closemenu: () => this.helpers.handleCategoryCloseMenu(`dataManagementMenu`)
    }
  }) : null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `brand-data-management` }
  })), this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom }
  }, `Data Management`) : null);
  const helpMenu = /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-help",
    class: {
      "mp-chrome-header-trigger-container-active": isOpen.helpMenu
    }
  }, /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      elref: `helpMenu`,
      "menu-width": 256,
      icon: `brand-help`,
      "disable-search": true,
      "icon-only": true,
      "menu-height": null,
      "align-all-text": true
    },
    props: {
      sectionsFn: () => this.helpers.getHelpMenuSections()
    },
    on: {
      change: this.helpers.helpMenuItemSelected,
      menuChange: (ev) => this.helpers.selectMenuChanged(`help`, ev.detail.isOpen)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container-icon",
    class: { "mp-chrome-header-trigger-container-notif": this.helpers.shouldShowHelpMenuNotif() },
    attrs: { slot: `trigger` }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `brand-help` }
  }))), this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom }
  }, `Help`) : null, this.state.showOnboardingChecklistHelpTooltip && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom, "always-show": true }
  }, `You can reopen Onboarding Guide from the Help tab`));
  const applicationMenu = /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container",
    class: {
      "mp-chrome-header-trigger-container-active": isOpen.applicationsMenu
    }
  }, /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      elref: `applicationsMenu`,
      "search-threshold": 10,
      "menu-width": 300,
      "menu-height": 400
    },
    props: {
      sectionsFn: () => this.helpers.getApplicationsMenuSections()
    },
    on: {
      change: this.helpers.menuItemSelected,
      menuChange: (ev) => this.helpers.selectMenuChanged(`applications`, ev.detail.isOpen)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container-icon",
    attrs: { slot: `trigger` }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `brand-applications` }
  }))), this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom }
  }, `Applications`) : null);
  const settingsMenu = /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container",
    class: {
      "mp-chrome-header-trigger-container-active": isOpen.setupMenu
    }
  }, /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      elref: `settingsMenu`,
      "empty-message": `Loading\u2026`,
      "disable-search": true,
      "menu-width": 280,
      "menu-height": 570
    },
    class: { "mp-chrome-header-trigger-container-notif": true },
    props: {
      sectionsFn: () => this.helpers.getSettingsMenuSections()
    },
    on: {
      click: this.helpers.warmUsageAnalyticsData,
      change: this.helpers.menuItemSelected,
      menuChange: (ev) => this.helpers.selectMenuChanged(`setup`, ev.detail.isOpen)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-trigger-container-icon",
    attrs: { slot: `trigger` },
    class: { "mp-chrome-header-trigger-container-notif": this.helpers.shouldShowSettingsMenuNotif() }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `brand-settings` }
  }))), this.helpers.shouldShowSettingsMenuNotif() ? /* @__PURE__ */ jsx(TooltipEl, {
    sel: ".startup-credit-tooltip",
    attrs: { "always-show": true, placement: Placement.Bottom, "max-width": `400px`, "break-word": true },
    style: { display: this.helpers.allMenusClosed() ? `` : `none` }
  }, track(events.viewedStartupCreditPromoTooltip), /* @__PURE__ */ jsx("div", {
    sel: ".tooltip-text-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".tooltip-close-icon-container"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".tooltip-close",
    attrs: { icon: `x` },
    on: { click: this.setViewedStartupCreditPromo }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".tooltip-title",
    style: { "font-size": `18px`, "line-height": `24px` }
  }, "Upgrade your plan from Free to Growth with your", ` `, numberInUSD(this.helpers.getStartupCreditBalances().remainingBalance), " of credits!"), /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("div", {
    sel: ".tooltip-body"
  }, "You have used ", /* @__PURE__ */ jsx("strong", null, numberInUSD(this.helpers.getStartupCreditBalances().creditUsageAmount)), " of", ` `, /* @__PURE__ */ jsx("strong", null, numberInUSD(this.helpers.getStartupCreditBalances().initialValue)), ` `, "of your Mixpanel Startup Credits. You have until", ` `, /* @__PURE__ */ jsx("strong", null, (_a = this.helpers.getStartupCreditInfo()) == null ? void 0 : _a.endDate), " to redeem your credits."), /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("div", {
    sel: ".upgrade-to-redeem-credits-btn-container"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary
    },
    on: {
      click: (ev) => {
        this.setViewedStartupCreditPromo();
        this.helpers.navigate(`/pricing/plan-builder`, ev, { fromAnchorlink: false });
        track(events.clickStartupPromoLink, { "Navigated From": `Tooltip Button` });
      }
    }
  }, "Upgrade to redeem credits")))) : this.helpers.allMenusClosed() ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom }
  }, `Settings`) : null);
  const projectMenu = /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-project-menu-container"
  }, (() => {
    var _a2;
    const displayWorkspaceSelection = this.helpers.areWorkspacesActivated();
    const projectsLength = this.helpers.getProjectsForMenu().length;
    return /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        elref: `projectsMenu`,
        "search-placeholder": displayWorkspaceSelection ? `Search data views` : `Search projects`,
        "menu-width": 300,
        "menu-height": 400,
        "back-button": displayWorkspaceSelection,
        "header-title": displayWorkspaceSelection ? `Data Views (${projectMenuWorkspaces.length})` : `Projects (${projectsLength})`
      },
      props: {
        sectionsFn: () => this.helpers.getProjectsMenuSections()
      },
      on: {
        backClick: this.helpers.selectProjectMenuBackClick,
        change: this.helpers.selectProjectMenuItem,
        menuChange: (ev) => this.helpers.selectMenuChanged(`project`, ev.detail.isOpen)
      },
      class: {
        "mp-chrome-project-menu-active": isOpen.projectMenu
      }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-btn",
      attrs: { slot: `trigger` }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-label-container"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-label",
      attrs: { title: this.helpers.getProjectAndWorkspaceName(false) }
    }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-label-project"
    }, this.getCurrentProjectName()), /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-label-workspace"
    }, ((_a2 = this.helpers.getCurrentWorkspace()) == null ? void 0 : _a2.name) || ``))), /* @__PURE__ */ jsx(SvgIconEl, {
      sel: ".mp-chrome-categories-label-filled-icon",
      attrs: { icon: `caret-down` }
    }))), displayWorkspaceSelection ? this.helpers.getUserHasCreateWorkspacePermission() ? /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-add",
      attrs: { slot: `footer` }
    }, /* @__PURE__ */ jsx(ButtonBarEl, {
      attrs: { theme: ButtonBarTheme.Secondary },
      on: { click: this.helpers.handleCreateWorkspaceBtnClick }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-button-bar-text"
    }, "Create Data View"))) : null : /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-add",
      attrs: { slot: `footer` }
    }, this.helpers.hasOrgs() && (!this.helpers.getOrgs()[0].id || this.helpers.getOrgsWithCreateProjectPermission().length) ? /* @__PURE__ */ jsx(ButtonBarEl, {
      attrs: { theme: ButtonBarTheme.Secondary },
      on: { click: this.helpers.clickedCreateProject }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-project-menu-button-bar-text"
    }, "Create Project")) : null));
  })());
  const getChromeCategoryItem = (href, report, label) => {
    return /* @__PURE__ */ jsx("a", {
      sel: ".mp-chrome-categories-category",
      attrs: {
        href,
        isActiveCategory: false,
        elref: `chromeCategory${label}`
      },
      on: { click: () => this.helpers.handleClickReportName(report, `Top Nav`) }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-categories-label-container"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-categories-label"
    }, label)));
  };
  const getChromeCategory = (category, name = ``) => {
    const isActiveCategory = category.name === selectedCategory;
    const reportsMenuOpen = category.reports && isActiveCategory;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-categories-category",
      attrs: {
        elref: `chromeCategory${category.name}`
      },
      class: {
        "mp-chrome-categories-category-active": isActiveCategory
      },
      on: {
        click: () => this.helpers.toggleSelectedCategory(category.name)
      }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-categories-label-container"
    }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-chrome-categories-label"
    }, name || category.label), /* @__PURE__ */ jsx(SvgIconEl, {
      sel: ".mp-chrome-categories-label-filled-icon",
      attrs: { icon: `caret-down` }
    }), reportsMenuOpen ? /* @__PURE__ */ jsx(ReportsMenuEl, {
      attrs: {
        "current-report-name": currentReportName,
        "project-id": projectId,
        reports: JSON.stringify(category.reports),
        order: JSON.stringify(category.order || Object.keys(category.reports)),
        open: true,
        "workspace-id": workspaceId
      },
      class: { "mp-chrome-categories-label-report-menu-new-nav": true },
      on: {
        closemenu: () => this.update({ selectedCategory: `` })
      }
    }) : null))));
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header",
    class: {
      "mp-chrome-header-root": true,
      "mp-chrome-header-hidden": this.attr(`hidden`)
    },
    hook: !this.attr(`hidden`) ? this.helpers.stickyElemHooks : {}
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-row-primary",
    class: {
      "mp-chrome-header-festive-mode": !!festiveMode
    }
  }, !((_b = this.getCurrentProject()) == null ? void 0 : _b.organizationId) ? null : /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-inner"
  }, festiveMode === FestiveMode.Luv ? /* @__PURE__ */ jsx(FestiveModeHeaderAnimEl, null) : null, projectId ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-left"
  }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("a", {
    sel: ".mp-chrome-header-left-avatar",
    attrs: {
      href: this.getBrowseUrl({ resetFilters: true })
    },
    on: { click: () => this.helpers.handleClickReportName(ReportName.Dashboards, `Home`) }
  }, /* @__PURE__ */ jsx(OrganizationIconEl, {
    attrs: { title: `Home` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-categories-container"
  }, getChromeCategoryItem(
    this.getBrowseUrl({
      queryParam: { "entity-type-filter": BrowseEntityTypeFilter.Dashboard },
      resetFilters: true
    }),
    ReportName.Dashboards,
    NavCategoryType.Dashboards
  ), getChromeCategory(
    categories ? categories[`analysis`] : { label: NavCategoryType.Analysis, name: `analysis`, reports: {} },
    `Reports`
  ), getChromeCategoryItem(this.getReportUrl(`users`), ReportName.Users, NavCategoryType.Users), getChromeCategoryItem(this.getReportUrl(`events`), ReportName.Events, NavCategoryType.Events)))) : null, shouldDisplayNavigationOptions ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-center",
    attrs: { elref: `chromeHeaderCenter` }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-categories-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-categories-container-search"
  }, /* @__PURE__ */ jsx(GlobalSearchEl, {
    params: {
      currentUrlPath: this.state.currentUrlPath
    }
  })))) : null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-header-right"
  }, shouldDisplayNavigationOptions ? dataManagementMenu : null, shouldDisplayNavigationOptions && this.helpers.currentProjectStoreHasValue() && !this.helpers.hasProjectFeatureFlag(ProjectFeatureFlag.HideMenuApps) ? applicationMenu : null, helpMenu, settingsMenu, projectMenu))), errorAlertMsg && /* @__PURE__ */ jsx(ToastPortalEl, {
    props: {
      toast: {
        isStatic: true,
        type: `error`,
        message: errorAlertMsg,
        closeToastCallback: this.helpers.handleErrorToastClosed
      }
    }
  }), createProjectError && /* @__PURE__ */ jsx(ToastPortalEl, {
    props: {
      toast: {
        isStatic: true,
        type: `error`,
        message: `Failed to create new project. Error: ${createProjectError}`
      }
    }
  }), isOpen.createProjectModal && this.helpers.hasOrgs() ? /* @__PURE__ */ jsx(CreateProjectModalEl, {
    attrs: { open: true, orgs: this.helpers.getOrgs(), "organization-id": this.helpers.orgIdForCreateProject() },
    on: { cancel: this.helpers.clickedCancel, create: this.helpers.clickedCreate }
  }) : null, isOpen.inviteModal ? useInviteV2((_c = this.getCurrentProject()) == null ? void 0 : _c.organizationId) ? /* @__PURE__ */ jsx(InviteUsersModalElV2, {
    attrs: {
      open: true,
      type: Tab.Project,
      "exclude-teams": true
    },
    props: {
      org: inviteModalOrgs.find((o) => {
        var _a2;
        return o.id === ((_a2 = this.getCurrentProject()) == null ? void 0 : _a2.organizationId);
      }),
      project: this.getCurrentProject()
    },
    on: {
      save: this.helpers.closeInviteModal,
      cancel: this.helpers.closeInviteModal,
      notify: this.helpers.handleNotify,
      error: this.helpers.handleError
    }
  }) : /* @__PURE__ */ jsx(InviteUsersModalEl, {
    attrs: {
      open: true
    },
    props: {
      orgs: inviteModalOrgs
    },
    on: {
      save: this.helpers.closeInviteModal,
      cancel: this.helpers.closeInviteModal,
      notify: this.helpers.handleNotify,
      error: this.helpers.handleError
    }
  }) : null, isOpen.searchModal ? /* @__PURE__ */ jsx(LoadEntityModalEl, {
    attrs: {
      open: true,
      "modal-title": `Open Report`,
      "project-id": projectId,
      "track-name": `Content Discovery`,
      "search-text": searchedText,
      "user-id": (_d = this.getCurrentUser()) == null ? void 0 : _d.id,
      "workspace-id": currentWorkspace ? currentWorkspace.id : 0,
      "filter-default-open": true,
      ...searchModalDisplayContext ? { "entity-type-filter": searchModalDisplayContext } : {}
    },
    on: {
      close: this.helpers.handleSearchModalClose
    }
  }) : null, showSupportWidget ? /* @__PURE__ */ jsx(SupportWidgetEl, {
    attrs: this.helpers.supportWidgetAttrs(),
    on: {
      close: this.helpers.closeSupportWidget
    },
    props: {
      maximize: isSupportWidgetMaximized
    }
  }) : null, this.helpers.showOnboardingChecklist() && /* @__PURE__ */ jsx(OnboardingChecklistEl, {
    params: {
      shouldCollapse: this.helpers.hasOpenModal(),
      dismissCallback: this.helpers.dismissOnboardingChecklist,
      completeCallback: this.helpers.completeOnboardingChecklist,
      inviteCallback: this.helpers.openInviteUserModal,
      viewingBoards: getReportName() === ReportName.Dashboards,
      userEmail: (_e = this.getCurrentUser()) == null ? void 0 : _e.email
    }
  }));
}
